import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomService } from '../shared/services/custom.service';
import { AuthService } from '../auth.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-details-discrepancy',
  templateUrl: './details-discrepancy.component.html',
  styleUrls: ['./details-discrepancy.component.css']
})
export class DetailsDiscrepancyComponent {

  //header message
  headerDisplay: any;
  //fields
  disId: any;
  drCat: any;
  opendate: any;
  closeddate: any;
  closeddateTime: any;
  openDays: any;
  frstUDdate: any;
  custNotifyDate: any;
  custNotifyDateTime: any;
  custNotifyVal: any;
  closedDateVal: any;
  pageNo: any;
  paraNo: any;
  tableNo: any;
  figNo: any;
  currDrCat: any;
  DrStatus: any;
  userID: any;
  usrUUID: any;
  usrFullName: any;
  useCompany: any;
  userEmail: any;
  pubNo: any;
  volume: any;
  ata: any;
  revisionDate: any;
  currentRev: any;
  orgRev: any;
  pubOrg: any;
  pubType: any;
  pubStatus: any;
  expotCode: any;
  pubLic: any;
  eng: any;
  comment: any;
  closeRes: any;
  closeCmtTextArea: any;
  other: any;
  valOther: any;
  //dropdown value
  drCatData: any;
  drStatusData: any
  //readonly
  isReadOnly = true;
  isDRStatus = true;
  isOther = false;
  //path
  pathId: any;
  searchId: any;
  fieldsLen: any;
  messageLen: any;
  responsLen: any;
  otherLen: any;
  //alert
  DRWarnMsg = '';
  DRalertMsg = '';
  dr_dtl_succss = '';
  valBottomError = false;
  valTopError = false;
  valErrorBottomMsg = '';
  valErrorTopMsg = '';

  constructor(private CustomService: CustomService, private router: Router,
    private route: ActivatedRoute, private datePipe: DatePipe,
    private authService: AuthService) { }

  ngOnInit() {
    //path check
    this.urlPathCheck();
  }

  urlPathCheck() {
    this.pathId = this.route.snapshot.params['id'];
    this.searchId = this.route.snapshot.params['id2'];
    this.pathId === 'E' ? this.headerDisplay = 'Discrepancy Details' : '';
    this.getAllDRDetails(this.searchId);
    this.currentDRCat();
    this.drStatus();
    this.checkAllFieldLength();
  }

  currentDRCat() {
    this.currDrCat = 'cateDr';
    this.CustomService.getAllCategory().subscribe((res: any) => {
      if (res && res.statusCode === 200) {
        this.drCatData = res.data;
      }
    });
  }

  onSelectDRCategory(val: any) {
    if (val === 27) {
      this.isOther = true;
    } else {
      this.isOther = false;
      this.other = this.valOther;
    }
  }

  drStatus() {
    this.DrStatus = 'status';
    this.CustomService.drStatusType().subscribe((res: any) => {
      if (res && res.statusCode === 200) {
        this.drStatusData = res.data;
      }
    });
  }

  checkAllFieldLength() {
    this.CustomService.checkFieldLength().subscribe((res: any) => {
      if (res && res.statusCode === 200) {
        this.fieldsLen = res.data;
        this.fieldData(this.fieldsLen);
      }
    });
  }

  fieldData(fieldLen: any) {
    let f1 = fieldLen.filter((item: any) => item.field === 'MESSAGE');
    this.messageLen = f1[0].maxlength;
    let f2 = fieldLen.filter((item: any) => item.field === 'RESPONSE');
    this.responsLen = f2[0].maxlength;
    let f3 = fieldLen.filter((item: any) => item.field === 'DESCRIPTION');
    this.otherLen = f3[0].maxlength;
  }

  onChangeStatus(DRStatus: any) {
    if (DRStatus === 3) {
      this.isDRStatus = false;
      this.custNotifyDate = this.custNotifyVal ? this.custNotifyVal : '';
      this.closeddate = this.datePipe.transform(new Date(), 'YYYY-MM-dd');
      this.closeddateTime = this.datePipe.transform(new Date(), 'YYYY-MM-dd HH:mm:ss');
    } else if (DRStatus === 2) {
      this.custNotifyDate = this.datePipe.transform(new Date(), 'YYYY-MM-dd');
      this.custNotifyDateTime = this.datePipe.transform(new Date(), 'YYYY-MM-dd HH:mm:ss');
      this.isDRStatus = true;
      this.closeRes = this.closeCmtTextArea ? this.closeCmtTextArea : '';
      this.closeddate = this.closedDateVal ? this.closedDateVal : '';
    } else {
      this.isDRStatus = true;
      this.closeRes = this.closeCmtTextArea ? this.closeCmtTextArea : '';
      this.custNotifyDate = this.custNotifyVal ? this.custNotifyVal : '';
      this.closeddate = this.closedDateVal ? this.closedDateVal : '';
    }
  }

  onKeyPressEvent(event: any, propName: any) {
    if (event.keyCode === 33 || event.keyCode === 64 || event.keyCode === 94 ||
      event.keyCode === 61 || event.keyCode === 124 ||
      event.keyCode === 60 || event.keyCode === 62) {
      event.preventDefault();
      if (propName === 'Others') {
        this.valErrorTopMsg = 'Special characters | @ ! ^ = < > are not allowed';
        this.valTopError = true;
      } else {
        this.valErrorBottomMsg = 'Special characters | @ ! ^ = < > are not allowed';
        this.valBottomError = true;
      }
      setTimeout(() => {
        this.valErrorTopMsg = '';
        this.valErrorBottomMsg = '';
      }, 5000);
    }
  }

  validationFields(): boolean {
    if (this.DrStatus !== 'status' && this.currDrCat !== 'cateDr') {
      if (this.DrStatus === 3 && this.currDrCat !== 27) {
        return this.DrStatus && this.closeRes && this.currDrCat;
      } else if (this.DrStatus !== 3 && this.currDrCat === 27) {
        return this.DrStatus && this.other && this.currDrCat;
      } else if (this.DrStatus === 3 && this.currDrCat === 27) {
        return this.DrStatus && this.closeRes && this.other && this.currDrCat;
      } else {
        return this.DrStatus && this.currDrCat;
      }
    } else {
      return false;
    }
  }

  getAllDRDetails(searchDrId: any) {
    this.CustomService.getAllDiscpDetails(searchDrId).subscribe((res: any) => {
      if (res && res.statusCode === 200 && res.data) {
        let dr_dtl = res.data;
        //fields auto population
        this.disId = dr_dtl.discid;
        this.drCat = dr_dtl.originaldrcategory;
        this.opendate = dr_dtl.opendatestr;
        this.closeddateTime = dr_dtl.closeddatestr;
        this.closeddate = dr_dtl.closeddatestr ? this.datePipe.transform(dr_dtl.closeddatestr, 'YYYY-MM-dd') : '';
        this.closedDateVal = dr_dtl.closeddatestr ? this.datePipe.transform(dr_dtl.closeddatestr, 'YYYY-MM-dd') : '';
        this.openDays = dr_dtl.opendays;
        this.frstUDdate = dr_dtl.firstupdatedatestr;
        this.custNotifyDateTime = dr_dtl.customernotifydatestr;
        this.custNotifyDate = dr_dtl.customernotifydatestr ? this.datePipe.transform(dr_dtl.customernotifydatestr, 'YYYY-MM-dd') : '';
        this.custNotifyVal = dr_dtl.customernotifydatestr ? this.datePipe.transform(dr_dtl.customernotifydatestr, 'YYYY-MM-dd') : '';
        this.pageNo = dr_dtl.pagenumber;
        this.paraNo = dr_dtl.paranumber;
        this.tableNo = dr_dtl.tablenumber;
        this.figNo = dr_dtl.figurenumber;
        this.currDrCat = dr_dtl.currentdrcategory;
        (this.currDrCat === 27) ? this.isOther = true : this.isOther = false;
        this.DrStatus = dr_dtl.drstatusid;
        (this.DrStatus === 3) ? this.isDRStatus = false : this.isDRStatus = true;
        this.userID = dr_dtl.userid;
        this.usrUUID = dr_dtl.useruuid;
        this.usrFullName = dr_dtl.username;
        this.useCompany = dr_dtl.usercompanyname;
        this.userEmail = dr_dtl.email;
        this.pubNo = dr_dtl.pubnumber;
        this.volume = dr_dtl.volume;
        this.ata = dr_dtl.atanumber;
        this.revisionDate = dr_dtl.revdatestr;
        this.currentRev = dr_dtl.currentrevnumber;
        this.orgRev = dr_dtl.originalrevnumber;
        this.pubOrg = dr_dtl.organization;
        this.pubType = dr_dtl.publicationtype;
        this.pubStatus = dr_dtl.pubstatus;
        this.expotCode = dr_dtl.exportcode;
        this.pubLic = dr_dtl.license;
        this.eng = (dr_dtl.eng) ? "TRUE" : "FALSE";
        this.comment = dr_dtl.reportingpartycomments;
        this.closeRes = dr_dtl.closingcomments;
        this.closeCmtTextArea = dr_dtl.closingcomments;
        this.other = dr_dtl.other;
        this.valOther = dr_dtl.other;
      }
    }, error => {
      if (error) {
        this.DRalertMsg = "Server is not responding";
        setTimeout(() => {
          this.DRalertMsg = '';
        }, 3000);
      }
    });
  }

  DRDetail() {
    let authUserId = localStorage.getItem('authUserId');
    let formData: any = new FormData();
    let splAvl = /[\|\@\!\^\=\<\>]/;
    if (this.other) {
      this.valTopError = splAvl.test(this.other);
    }
    this.valBottomError = splAvl.test(this.closeRes);
    if (!this.valBottomError && !this.valTopError) {
      formData.append('DISCID', this.disId);
      formData.append('CURRENTDRCATEGORY', this.currDrCat);
      formData.append('DRSTATUSID', this.DrStatus);
      formData.append('CLOSINGCOMMENTS', this.closeRes);
      formData.append('CUSTOMERNOTIFYMESSAGE', '');
      formData.append('OTHER', this.other ? this.other : '');
      formData.append('CUSTOMERNOTIFYDATE', this.custNotifyDateTime ? this.custNotifyDateTime : '');
      formData.append('CLOSEDDATE', this.closeddateTime ? this.closeddateTime : '');
      formData.append('USERID', authUserId);
      this.CustomService.saveDiscrepancyDetails(formData).subscribe((res: any) => {
        if (res && res.statusCode === 200 && res.data) {
          this.dr_dtl_succss = "Records Updated Successfully.";
          setTimeout(() => {
            this.dr_dtl_succss = '';
            this.router.navigate(['search-discrep']);
          }, 3000);
        }
        if (res?.message === 'Invalid user') {
          this.DRWarnMsg = "Something went wrong due to Invalid User!";
        }
        setTimeout(() => {
          this.DRWarnMsg = '';
        }, 3000);
      }, error => {
        if (error?.error?.message === 'Invalid user') {
          this.DRWarnMsg = "Something went wrong due to Invalid User!";
        } else {
          this.DRWarnMsg = "Server is not responding!";
        }
        setTimeout(() => {
          this.DRWarnMsg = '';
        }, 3000);
        this.valBottomError = false;
        this.valTopError = false;
        this.valErrorBottomMsg = '';
        this.valErrorTopMsg = '';
      });
    } 
  }

  logout() {
    this.authService.logout();
  }
}
